import { BUTTON_CONSTANTS } from "@/core/constants/common/button-contants";
import { ELEMENT_ID } from "@/core/constants/common/element-constants";
import { IConnectedApp } from "@/core/interfaces/usestate-interfaces";
import FormWrapper from "@/core/wrappers/form-wrapper";
import { Form } from "devextreme-react";
import { t } from "i18next";
import { useCallback, useRef, useState } from "react";
import { connectedAppService } from "../../../../projects/platform/services/connected-app-services";
import { HttpStatusCode } from "axios";
import Countdown from "react-countdown";
import PermissionWrapper from "@/core/wrappers/permission-wrapper";
import { PERMISSION_CONSTANTS } from "@/core/constants/common/permission-constants";


const ConnectApp = () => {
    const duration = 120;
    const [key, setKey] = useState(0);
    const [showVerificationCode, setShowVerificationCode] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [endDate, setEndDate] = useState(Date.now() + duration * 1000);
    const formRef: any = useRef<Form>();
    const [connectedApp] = useState<IConnectedApp>({ countryCode: '', contactInfo: '', appType: '' });
    const phoneEditorOptions = { mask: '(000) 000-0000' };
    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const form = formRef.current.props.formData;
                form.contactType = "phone";
                form.contactInfo = form.countryCode + form.contactInfo;
                const result = await connectedAppService.createAsync(form);
                resolve();
                if (result.status == HttpStatusCode.Ok) {
                    formRef.current.instance.resetValues();
                    resetCounter();
                    setVerificationCode(result.message);
                    setShowVerificationCode(true);
                }
            } catch (error) {
                reject(error)
            }
        })
    }, []);

    const resetCounter = async () => {
        setKey(prevKey => prevKey + 1);
        setEndDate(Date.now() + duration * 1000);
    }

    const countryCodeEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'countryCodes' },
        dataSource: [{ "id": "90", "name": "90 - Turkiye" }],
        displayExpr: "name",
        valueExpr: "id",
        searchEnabled: true

    };
    const appTypeEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'countryCodes' },
        dataSource: [{ "id": "whatsapp", "name": "Whatsapp" }],
        displayExpr: "name",
        valueExpr: "id",
        searchEnabled: true

    };
    return (
        <PermissionWrapper permission={PERMISSION_CONSTANTS.CONNECTED_APP} action="Create">
            <div className='view-wrapper'>
                <FormWrapper
                    onSubmit={handleSubmit}
                    formRef={formRef}
                    formData={connectedApp}
                    isAddBackBtn={false}
                    buttonGroups={[
                        { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
                    ]}
                    simpleItemGroups={[
                        {
                            useColCountByScreen: false,
                            items: [
                                {
                                    dataField: "countryCode",
                                    editorType: "dxSelectBox",
                                    editorOptions: countryCodeEditorOptions,
                                    label: t('country_code'),
                                    isRequired: true,
                                    requiredMessage: 'country_code_is_required'
                                },
                                {
                                    dataField: 'contactInfo',
                                    label: t('phone_number'),
                                    editorOptions: phoneEditorOptions,
                                    isRequired: true,
                                    requiredMessage: 'phone_number_is_required'
                                },
                                {
                                    dataField: "appType",
                                    editorType: "dxSelectBox",
                                    editorOptions: appTypeEditorOptions,
                                    label: t('app_type'),
                                    isRequired: true,
                                    requiredMessage: 'app_type_is_required'
                                },
                            ]
                        }
                    ]}
                />
                <h1 className='text-gray-900 fw-bolder mb-3' hidden={!showVerificationCode}>
                    {t('start_talk')} {verificationCode}
                    <Countdown
                        key={key}
                        date={endDate}
                        intervalDelay={1000}
                        precision={0}
                        renderer={props => <div>{props.total / 1000} {t('seconds_left')}</div>}
                    />
                </h1>
            </div>
        </PermissionWrapper>
    )
}
export default ConnectApp
